export default [
  'addgraph',
  'addmenuitem',
  'addnode',
  'addnote',
  'addobject',
  'addplot',
  'addrule',
  'addscalevalue',
  'appendseriesdata',
  'appendseriesvalues',
  'clearfeed',
  'clearscroll',
  'clearselection',
  'clicknode',
  'clicknode',
  'closemodal',
  'closemodal',
  'destroy/zcdestroy',
  'disable',
  'downloadCSV',
  'downloadRAW',
  'downloadXLS',
  'exitfullscreen',
  'exportdata',
  'exportimage',
  'fullscreen',
  'get3dview',
  'getbubblesize',
  'getcharttype',
  'getdata',
  'getgraphlength',
  'getimagedata',
  'getinterval',
  'getnodelength',
  'getnodevalue',
  'getobjectinfo',
  'getoriginaljson',
  'getpage',
  'getplotlength',
  'getplotvalues',
  'getrender',
  'getrules',
  'getscaleinfo',
  'getscales',
  'getseriesdata',
  'getseriesdata',
  'getseriesvalues',
  'getversion',
  'getxyinfo',
  'goback',
  'goforward',
  'hideguide',
  'hidemenu',
  'hideplot/plothide',
  'hidetooltip',
  'legendmaximize',
  'legendminimize',
  'legendscroll',
  'load',
  'loadstorage',
  'mapdata',
  'mapdata',
  'modify',
  'modifyplot',
  'openmodal',
  'print',
  'reload',
  'removegraph',
  'removenode',
  'removenote',
  'removeobject',
  'removeplot',
  'removerule',
  'removescalevalue',
  'repaintobjects',
  'resize',
  'saveasimage',
  'set3dview',
  'setcharttype',
  'setdata',
  'setguide',
  'setinterval',
  'setmode',
  'setnodevalue',
  'setpage',
  'setscalevalues',
  'setseriesdata',
  'setseriesvalues',
  'showhoverstate',
  'showmenu',
  'showplot/plotshow',
  'showtooltip',
  'startfeed',
  'stopfeed',
  'togglebugreport',
  'toggledimension',
  'togglelegend',
  'toggleplot',
  'unbinddocument',
  'update',
  'updatenote',
  'updateobject',
  'updaterule',
  'viewDataTable',
  'zoomin',
  'zoomout',
  'zoomto',
  'zoomtovalues'
];
